import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';

import { colors } from '@/lib/analytics/colors';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_25 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const storiesSharesConfig = {
    name: 'kpi.instagram.stories.stories_shares',
    id: 'stories_shares',
    icon: {
        name: 'share',
        style: colors.aquablue
    },
    tooltip: 'kpi.instagram.stories.tooltip_stories_shares',
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    data_format: KPI_VALUE_CLASSIC,
    size: SIZE_25,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    element: KPIDefault,
    noDataToken: 'analytics:kpi.instagram.stories.no_stories_period',
    loader: DefaultLoader,
    new: {
        dateAdded: '2025-08-06'
    }
};
